import Footer from "../../common/Footer";
export interface CarouselData {
  image: string;
  title: string;
  text: string;
}

export const carouselData: CarouselData[] = [
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: "WELCOME TO OUR COMPANY",
    text: "Acu Trans Solutions is a professionally managed Medical Transcription Service company maintaining very high standards in providing medical transcription services to US clinics and hospitals.",
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: "EXCEPTIONAL SERVICES",
    text: "Acu Trans Solutions is a professionally managed Medical Transcription Service company maintaining very high standards in providing medical transcription services to US clinics and hospitals.",
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: "DEDICATED TEAM",
    text: "Acu Trans Solutions is a professionally managed Medical Transcription Service company maintaining very high standards in providing medical transcription services to US clinics and hospitals.",
  },
];

export interface UPValidation {
    username: string;
    password: string;
  }
  
  export const upCriteria: UPValidation = {
    username: "Please enter your username.\n",
    password: "Please enter your password.",
  };
  
export interface PasswordCriteria {
  title: string;
  list: string[];
}

export const passwordCriteria: PasswordCriteria = {
  title: "Password Must:",
  list: [
    "Include lower and upper character",
    "Include at least 1 number or symbol",
    "Be at least 8 characters long",
    "Match in both fields",
  ],
};

export interface ValidationMessages {
  invalidCredentials: string;
  notAuthorized: string;
  accountVerificationPending: string;
  accountInactive: string;
  accountLocked: string;
  passwordChanged: string;
  currentPasswordMismatch: string;
  reusedPassword: string;
  currentNewPasswordSame: string;
  correctOtp: string;
  currentPassword: string;
  newPassword : string;
  passwordError: string;
  confirmpassword: string;
  passwordMismatch:string;
  invalidUser: string;
  enterOtp: string;
  loginSuccess : string;
  enterEmail : string;
  validEmail : string;
  emailNotFound: string;
  emailFound : string;
}

export const validationMessages: ValidationMessages = {
  invalidCredentials: "Invalid Username or Password Entered, Please Retry !!!",
  notAuthorized:
    // "Login Not Authorized, Please Call Customer Service <+1-###-###-####> for further help !!!",
    "Account Locked !! Please contact System Admin",
  accountVerificationPending: "Check your email for a verification link, and follow the instructions to complete the process. If you have not received the email, please check your spam or junk folder.",
  accountInactive:
    "Account In-Active, Please Call Customer Service <+1-###-###-####> for further help !!!",
  accountLocked:
    "Your account has been locked due to multiple invalid login attempts. Please try again later.",
  passwordChanged: "Password changed successfully.",
  currentPasswordMismatch: "Current password does not match.",
  reusedPassword:
    "The new password has been used in the last 3 password changes.\n Please choose a different one.",
  currentNewPasswordSame: "Current and new passwords cannot be the same.",
  correctOtp: "Please enter correct OTP.",
  currentPassword : "Please enter your current password.\n",
  newPassword : "Please enter your new password.\n",
  passwordError : "New password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.\n",
  confirmpassword : "Please enter your confirm password.\n",
  passwordMismatch:"New password and confirm password do not match.\n",
  invalidUser : "Invalid user, cannot change password.",
  enterOtp : "Please enter OTP.",
  loginSuccess : "Login successfully.",
enterEmail : " Please enter email address",
validEmail : "Please enter a valid email address",
emailNotFound : "Email ID does not exist",
emailFound : "Password reset email sent",
};

// Timer duration in seconds
export const TIMER_DURATION: number = 120;

const currentYear = new Date().getFullYear();
export const footerText: string = `Copyright © ${currentYear} - All rights reserved. Acu Trans Solutions LLC.`;
export const termsAndPolicyText: string =
  "Terms and Conditions | Privacy Policy";
